import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseDetailsContainer from '../../baseContainers/BaseDetailsContainer';
import {withRouter} from 'react-router-dom/cjs/react-router-dom.min';
import EventService from '../../services/EventService';
import { FullCalendarComponent } from '../../components/FullCalendarComponent';
import EventDialog from './EventDialog';
import { t } from 'i18next';
import { CustomMessages } from '../../components/CustomMessages';
import moment from 'moment';

class EventContainer extends BaseDetailsContainer {
    constructor(props) {
        super(props, new EventService());
        this.state = {
            loading: true,
            dialogVisibile: false,
            events:[],
            eventId:undefined,
            dialogViewMode: undefined,
            criteria: this.getCleanSearchCriteria(),
            
        };
        this.fetchDataForDateRange = this.fetchDataForDateRange.bind(this);
    }
    getCleanSearchCriteria() {
        return {
            endDate: null,
            startDate: null,
        };
    }

    getCriteriaName() {
        return 'event-list-sc';
    }
    getContainerListName(){
        return 'event-list';
    }
    getUpdateSucces() {
        return t("event.updated");
    } 
    getAddSucces() {
        return t("event.added");
    }
    initBeforeSetElement(){
       // this.fetchList();    
    }

    fetchList = (criteria) =>{
        this.service.getList(criteria).then((data)=>{
            this.setState({
                events: data.content,
                loading: false ,
            })
        }).catch((err)=>{
            this.showErrorMessage(err.message)
        })
    }

    prepareFooterItems() {
        return [];
    }
    
    render() {
        return (
            <React.Fragment>
                <div className='container-fluid'> {this.renderView()}</div>
            </React.Fragment>
        );
    }
    breadCrumbItems() {
        return [
            {name: t("event.event"), url: '/event-list'},
        ];
    }

    renderEventDialog = () => {
        return <div className='row'> 
                    <EventDialog 
                        id="event-dialog"
                        style={{maxWidth:"1400px"}}
                        elementId={this.state.eventId}
                        className={"col-10"}
                        blockUi = {this.blockUi}
                        unblockUi = {this.unblockUi}
                        viewMode={this.state.dialogViewMode}
                        visible = {true}
                        onHide={()=>{
                            this.setState({
                                showEventDialog: false,
                                elementId: undefined,
                            }) 
                        }}
                        afterSave={()=>{
                            this.readMessage();
                            this.setState({
                                showEventDialog: false,
                                elementId: undefined,
                            },()=>{
                                this.fetchList(this.state.criteria);
                                this.unblockUi()
                            })
                        }}
                        dateFrom={moment(this.state.criteria.startDate).add(5, 'days').startOf('month').toDate()}
                    />
            </div> 
    }
    fetchDataForDateRange(startDate, endDate) {
        // Aktualizacja stanu tylko, jeśli daty się zmieniły
        if (this.state.criteria.startDate?.getTime() !== startDate.getTime() || this.state.criteria.endDate?.getTime() !== endDate.getTime()) {        
            this.setState(prevState => ({
                criteria: {
                    ...prevState.criteria,
                    startDate,
                    endDate,
                }
            }), () => {
                // Implementacja logiki pobierania danych
                // Możesz użyć fetch lub axios do pobrania danych z serwera
                console.log(`Fetching data for date range: ${startDate} to ${endDate}`);
                this.fetchList(this.state.criteria);
            });
        }
    }

    renderDetails() {
        return (
            <React.Fragment>
                <CustomMessages id='custom-messages' ref={(el) => (this.messages = el)} rendered={!this.props.embedded} />
                <FullCalendarComponent 
                    events = {this.state.events}
                    currentLocale={this.state.locale} 
                    eventClick={(el)=>{
                        this.setState({
                            showEventDialog: true,
                            dialogViewMode:"EDIT",
                            eventId:el.event._def.publicId
                        })
                    }}
                    addEventClick={()=>{
                        this.setState({
                            showEventDialog: true,
                            dialogViewMode:"NEW"
                        })
                    }}
                    fetchDataForDateRange={this.fetchDataForDateRange} 
                />
                {this.state.showEventDialog  && this.renderEventDialog()}
            </React.Fragment>
        );
    }
}

EventContainer.defaultProps = {
    lazy: true,
};

EventContainer.propTypes = {
};

export default withRouter(withTranslation()(EventContainer));
